import { RiskLevel } from "@/model/RiskLevel";
import CountyDurhamLogo from "@/assets/regions/county-durham-logo.png";
const CountyDurhamBanner = {
    rawCopy: "For alcohol advice and support, call County Durham Drug and Alcohol Recovery Service on 03000 266 666 or find out more <u>here</u>.",
    logoLink: "https://codurhamrecovery.co.uk/"
};
export default {
    name: "County Durham",
    logo: {
        file: CountyDurhamLogo,
        width: 294,
        height: 260
    },
    zoomLevel: 10,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: CountyDurhamBanner,
        [RiskLevel.Lower]: CountyDurhamBanner,
        [RiskLevel.Increasing]: CountyDurhamBanner,
        [RiskLevel.Higher]: CountyDurhamBanner,
        [RiskLevel.High]: CountyDurhamBanner
    },
    clinics: [
        {
            name: "County Durham Drug and Alcohol Recovery Service",
            isPrimaryProvider: true,
            tagline: "Appointment only service for adults and young people.",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment, or you can request a call back <a href='https://codurhamrecovery.co.uk/contact' target='_blank'>here</a><br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Phone lines open:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "cddars.adult@waythrough.org.uk",
            website: "https://codurhamrecovery.co.uk"
        },
        {
            name: "County Durham Drug and Alcohol Recovery Service - Bishop Auckland",
            tagline: "(Appointment only service for adults and young people.)",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment.<br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1900 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            location: { lat: 54.6638228, lng: -1.6798252 },
            address: "Saddler House, Saddler Street, Bishop Auckland, DL14 7BH",
            email: "cddars.adult@waythrough.org.uk",
            website: "https://codurhamrecovery.co.uk"
        },
        {
            name: "County Durham Drug and Alcohol Recovery Service - Consett",
            tagline: "(Appointment only service for adults and young people.)",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment.<br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            location: { lat: 54.8514492, lng: -1.8311898 },
            address: "Womens Recovery Academy, Eden House, 1 Station Road, Consett, DH8 5RL",
            email: "cddars.adult@waythrough.org.uk",
            website: "https://codurhamrecovery.co.uk"
        },
        {
            name: "County Durham Drug and Alcohol Service - Centre for Change",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment.<br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1900 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            location: { lat: 54.771918, lng: -1.5683924 },
            address: "81-88 Whinney Hill, Old Elvet, Durham, DH1 3BQ",
            email: "cddars.adult@waythrough.org.uk"
        },
        {
            name: "County Durham Drug and Alcohol Service - Peterlee",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment.<br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1900 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            location: { lat: 54.7570372, lng: -1.3369676 },
            address: "Bede Way, Peterlee, SR8 1AD",
            email: "cddars.adult@waythrough.org.uk",
            website: "https://codurhamrecovery.co.uk"
        },
        {
            name: "County Durham Drug and Alcohol Service - Horden",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:03000 266 666'>Call</a> or <a href='mailto:cddars.adult@waythrough.org.uk'>email</a> to arrange an appointment.<br><br>",
            phone: ["03000 266 666"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1900 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            location: { lat: 54.7732294, lng: -1.3244446 },
            address: "Sunderland Road, Horden, Peterlee, SR8 4NU",
            email: "cddars.adult@waythrough.org.uk",
            website: "https://codurhamrecovery.co.uk"
        }
    ]
};
//# sourceMappingURL=CountyDurham.js.map